import { render, staticRenderFns } from "./PhoneList.vue?vue&type=template&id=03559068&scoped=true&"
import script from "./PhoneList.vue?vue&type=script&lang=js&"
export * from "./PhoneList.vue?vue&type=script&lang=js&"
import style0 from "./PhoneList.vue?vue&type=style&index=0&id=03559068&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03559068",
  null
  
)

export default component.exports